import React from 'react';
import { Card, Col, Row, Typography } from 'antd';
import { Colors } from '@common/tokens';
import { BillingStatsItemFragmentType } from '@pay-bill/graphql';

const { Title } = Typography;

export const BillingStats = (props: {
  data: BillingStatsItemFragmentType[] | undefined;
}) => {
  return (
    <div className="BillingStats">
      {props.data?.map((data, index) => (
        <Card
          key={index}
          className="billing-stats-card"
          style={{ marginRight: 20 }}
          title={
            <span className="title-text" style={{ paddingRight: '20px' }}>
              {data.title}
            </span>
          }
          headStyle={{ backgroundColor: Colors.elmHyperlight }}
          bodyStyle={{ padding: '12px 16px 10px 16px' }}
          extra={<span className="extra-text">{data.subtitle}</span>}
        >
          <Row gutter={16} id="state-row">
            {data.counts.length > 0 ? (
              data.counts.map((count, index) => (
                <Col className="state-col" key={index}>
                  <div className="state-count-label">{count.label}</div>
                  <Title level={4}>{count.value}</Title>
                </Col>
              ))
            ) : (
              <Row>
                <p className="empty-message">{data.emptyMessage}</p>
              </Row>
            )}
          </Row>
          {data.footer && (
            <Row id="footer-row">
              <Col className="footer-col">
                {data.footer.label} {data.footer.value}
              </Col>
            </Row>
          )}
        </Card>
      ))}
      <style jsx>
        {`
          .BillingStats {
            display: flex;
          }
          .BillingStats :global(.state-col) {
            align-content: center;
            text-align: center;
            padding-left: 8px;
            padding-right: 8px;
          }
          .BillingStats :global(.state-count-label) {
            margin-bottom: 8px;
          }
          .BillingStats .title-text {
            font-size: 16px;
            line-height: 0;
            letter-spacing: 0;
            font-weight: 600;
            text-transform: none;
          }
          .BillingStats .extra-text {
            font-size: 10px;
            color: ${Colors.midnightLighter};
          }
          .BillingStats .empty-message {
            color: ${Colors.steelDarker};
            font-style: italic;
            padding-top: 12px;
            padding-left: 8px;
            padding-bottom: 10px;
          }
          .BillingStats :global(#footer-row) {
            border-top: 1px solid ${Colors.steelLighter};
            padding-top: 10px;
            margin: 0 -16px;
          }
          .BillingStats :global(.footer-col) {
            color: ${Colors.midnightLighter};
            padding-left: 16px;
          }
          .BillingStats :global(.ant-card-extra) {
            padding-top: 10px;
            padding-bottom: 10px;
          }
        `}
      </style>
    </div>
  );
};
